import { employeeAPI } from '../../Pages/api';

let _cache = null;
let _promise = null;

export const getDistinctFilters = () => {
  if (_cache) return Promise.resolve(_cache);
  if (_promise) return _promise;

  _promise = employeeAPI.getDistinctFilters()
    .then((data) => {
      _cache = {
        branches: Array.isArray(data.branches) ? data.branches : [],
        zones: Array.isArray(data.zones) ? data.zones : [],
        franchises: Array.isArray(data.franchises) ? data.franchises : [],
        branchFranchiseMap: data.branchFranchiseMap && typeof data.branchFranchiseMap === 'object' ? data.branchFranchiseMap : {},
      };
      _promise = null;
      return _cache;
    })
    .catch((err) => {
      _promise = null;
      throw err;
    });

  return _promise;
};

export const prefetchDistinctFilters = () => {
  getDistinctFilters().catch(() => {});
};

export const clearDistinctFiltersCache = () => { _cache = null; };

export default _cache;
